// src/user/Signup.js

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import './Signup.css';
import LocalStorageUtil from '../user/LocalStorageUtil';

const Signup = () => {
  const baseHostUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:80';
  const baseLocalDevUrl = process.env.NODE_ENV === 'production' ? 'https://growlemma.com' : 'http://localhost:3000';
  const [username, setUsername] = useState('');
  const [userpassword, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  const handleSignup = async () => {
    if (userpassword !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      return;
    }
    try {
      const response = await axios.post(`${baseHostUrl}/signup`, {
        username,
        userpassword
      },{
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      }
    );
      // Save session locally
    LocalStorageUtil.saveSession({
      username,
      usrprofile: response.data.usrprofile || {}
    });
 
      // Redirect to lemma page
      navigate('/dashboard');
      //window.location.replace('/lemma');
    } catch (error) {
      //alert('Signup failed!');
      console.error(error);
    }
  };

  return (
    <div className="sign_wrapper">
      <div className="sign_container">
        <h2 className="sign_title">Sign Up</h2>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          className="sign_input"
        />

        <input
          type="password"
          placeholder="Password"
          value={userpassword}
          onChange={e => setPassword(e.target.value)}
          className="sign_input"
        />
      <input
        className="sign_input"
        type="password"
        placeholder="Confirm Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
        {errorMessage && <p className="sign_error">{errorMessage}</p>}
        <button
          onClick={handleSignup}
          className="sign_button"
        >
          Sign Up
        </button>
      </div>
    </div>
  );
};

export default Signup;
